// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import JcUiView from 'jc-ui-vue'
// import i18n from '@/locale'
import config from '@/config'
import Cookie from 'js-cookie'
import importDirective from '@/directive'
import 'iview/dist/styles/iview.css'
import './index.less'
import '@/api'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import VueSimpleUEditor from 'vue-simple-ueditor'
import '@/assets/scss/index.scss'
import 'static/iconfont/iconfont.css'
import '@/assets/icons/iconfont.css'
import ElementUI, { Message } from 'element-ui'
import '@/assets/scss/element-variable.scss'
import dom from '@/utils/dom'
import Const from '@/utils/const'
import Mixins from '@/utils/mixins'
import ViewerFile from '@/utils/viewersFile.js'
import Components from '@/components'
import importDirectives from '@/utils/directives'
import Uploader from '@/components/uploader'
import option from '@/components/Option'
import 'viewerjs/dist/viewer.css'
import { initFilters } from '@/utils/filters'
import './utils/echarts'
import scroll from 'vue-seamless-scroll'

Vue.prototype.$msg = Message

// import '@/mock'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
Vue.use(mavonEditor)
Vue.use(iView)
Vue.use(option)
Vue.use(ElementUI, { size: 'medium' })
Vue.use(JcUiView)
Vue.use(VueSimpleUEditor)
Vue.mixin(Mixins)
Vue.use(Components)
Vue.use(Uploader)
Vue.use(scroll)
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$cookie = Cookie
Vue.prototype.$dom = dom
Vue.prototype.$const = Const
Vue.prototype.$message = Vue.prototype.$Message
// 配置吐司提示停留时间
Vue.prototype.$Message.config({
  duration: 3
})
//文件预览
Vue.prototype.$openFile = ViewerFile

/**
 * 注册指令
 */
importDirective(Vue)
importDirectives(Vue)
initFilters(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // i18n,
  store,
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js